import { TypographyCaption, TypographyP2Bold } from '@heidi/design-system/typography';
import { CircleCheck, TriangleAlert } from 'lucide-react';
import { useIntl } from 'react-intl';

import type { ReportIssueType } from '../../../contracts/report-issue.types';
import { reportIssueResultMessages as messages } from './ReportIssueResultCard.messages';

export interface ReportIssueResultCardProps {
  /** Names the team that received the report in the success copy. */
  issueType: ReportIssueType;
  /** Intercom ticket / conversation reference; absent on failure. */
  ticketReference?: string;
  failed?: boolean;
}

/** Timeline receipt for a resolved `report_issue` call. */
export const ReportIssueResultCard = ({
  issueType,
  ticketReference,
  failed = false,
}: ReportIssueResultCardProps) => {
  const intl = useIntl();

  if (failed || !ticketReference) {
    return (
      <div
        className="my-4 rounded-lg border border-border bg-surface-accent px-4 py-3 first:mt-0"
        data-testid="report-issue-result-card"
      >
        <div className="flex items-center gap-1.5">
          <TriangleAlert className="size-3.5 text-validation-warning" />
          <TypographyP2Bold className="text-text-primary">
            {intl.formatMessage(messages.failedTitle)}
          </TypographyP2Bold>
        </div>
        <TypographyCaption className="mt-1 block text-text-secondary">
          {intl.formatMessage(messages.failedBody)}
        </TypographyCaption>
      </div>
    );
  }

  return (
    <div
      className="my-4 rounded-lg border border-border bg-surface-accent px-4 py-3 first:mt-0"
      data-testid="report-issue-result-card"
    >
      <div className="flex items-center gap-1.5">
        <CircleCheck className="size-3.5 shrink-0 text-validation-success" />
        <TypographyP2Bold className="text-pretty text-text-primary">
          {intl.formatMessage(
            issueType === 'safety' ? messages.submittedSafety : messages.submitted
          )}
        </TypographyP2Bold>
      </div>
    </div>
  );
};
